// @core/stores/booking/BookingAvailabilityStore.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { makeAutoObservable, runInAction } from 'mobx';
import { bookingApi } from '@core/api';
import type {
  GetAvailableSlotsResponse,
  SearchAvailableResourcesRequest,
  SearchAvailableResourcesResponse,
} from '@core/types/booking';

class BookingAvailabilityStore {

  // Loading states
  isLoading = false;

  // Error state (stores full ApiClientError for request context)
  error: unknown = null;

  constructor() {
    makeAutoObservable(this);
  }

  // Actions
  setError(error: unknown): void {
    this.error = error;
  }

  clearError(): void {
    this.error = null;
  }

  reset(): void {
    this.error = null;
  }

  /**
   * Get available slots
   */
  async GetAvailableSlots(resource_id: string, params?: { date_from?: string | number | boolean; date_to?: string | number | boolean; duration?: string | number | boolean; guest_count?: string | number | boolean; }): Promise<GetAvailableSlotsResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await bookingApi.GetAvailableSlots(resource_id, params);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }

  /**
   * Search available resources
   */
  async SearchAvailableResources(data: SearchAvailableResourcesRequest): Promise<SearchAvailableResourcesResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await bookingApi.SearchAvailableResources(data);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }
}

export const bookingAvailabilityStore = new BookingAvailabilityStore();
